
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-warning",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-warning"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{staticClass:"i-warning__circle",attrs:{"cx":"9","cy":"9","r":"6.15"}}),_c('path',{attrs:{"d":"M9 6.01v3.9"}}),_c('circle',{attrs:{"cx":"9","cy":"11.4","r":".1"}})])
          )
        }
      }
    